import MonthlyMonitoringFilter from './filters/MonthlyMonitoringFilter'
import TrainingResignationFilter from './filters/TrainingResignationFilter'
import StatutoryClosureFilter from './filters/StatutoryDisclosureFilter'
import {
  fetchFilter,
  fetchLatestSecondmentType,
  fetchLatestStdFmtData,
  fetchSecondmentTypeOptionList
} from './filters/services'
import { analysisMode } from '../../_constants/Code'

// const dashboardParams = {
//   '6.1.2': ['selectedYearMonth', yearMonth],
//   '6.2.2': ['selectedYearMonth', yearMonth],
//   '6.2.3': ['selectedYearMonth', yearMonth],
//   '5.2.3': ['latestYearMonth', latestYearMonth],
//   '5.2.4': ['latestYearMonth', latestYearMonth],
//   '5.2.5': ['latestYearMonth', latestYearMonth],
//   '5.2.6': ['latestYearMonth', latestYearMonth],
//   '5.2.7': ['latestYearMonth', latestYearMonth],
//   '5.2.8': ['latestYearMonth', latestYearMonth],
//   '10.1.5': ['latestYearMonth', latestYearMonth]
// }

/**
 * @typedef {object} FactoryParams
 * @property {string} dashboardId
 * @property {Record<string, unknown>} props QuickSightコンポネントのprops
 * @property {string} yearMonth 選択中の年月度データ
 */

/**
 * @function createMonthlyMonitoringFilterConfig 月次モニタリングのフィルター
 * @param {FactoryParams} params
 */
export const createMonthlyMonitoringFilterConfig = async (params) => {
  const { dashboardId, yearMonth, props } = params

  const result = await fetchFilter(dashboardId, props, {
    selectedYearMonth: (yearMonth || '')?.replaceAll('度', '')
  })

  const config = new MonthlyMonitoringFilter(result)
  await config.init()
  return config.getConfig()
}

export const monthlyMonitoringFilterPattern = () => ['layerLevel', '(department)(\\d{1,2})']

/**
 * @function createTrainingResignationFilterConfig
 *
 *   育成と離職防止のフィルター
 * @param {FactoryParams} params
 */
export const createTrainingResignationFilterConfig = async (params, type) => {
  const { dashboardId, props } = params
  const latestYearMonth = await fetchLatestStdFmtData(props)

  const result = await fetchFilter(dashboardId, props, {
    latestYearMonth: (latestYearMonth || '')?.replaceAll('度', '')
  })

  const config = new TrainingResignationFilter(result, type)
  await config.init()
  return config.getConfig()
}

export const trainingResignationFilterPattern = () => [
  'layerLevel',
  '(department)(\\d{1,2})',
  'certificationList',
  'scoreAnalysisCert',
  'score',
  'certList',
  'scoringAggregation'
]

/**
 * @function createTrainingResignationFilterConfig
 *
 *   法定開示設定
 * @param {FactoryParams} params
 * @param {Parameters<typeof fetchLatestSecondmentType>[1]} type
 */
export const createStatutoryDisclosureFilter = async (params, type) => {
  const { dashboardId, props } = params

  const secondmentTypeOptions = fetchSecondmentTypeOptionList()
  const secondmentTypeValue = await fetchLatestSecondmentType(props, type)

  const config = new StatutoryClosureFilter({
    secondmentTypeOptions,
    secondmentTypeValue,
    dashboardId,
    mode: props.mode
  })
  await config.init()
  return config.getConfig()
}

export const statutoryDisclosurePattern = (params) =>
  params?.mode === analysisMode.standalone ? ['section', 'secondmentType'] : ['groupby', 'section', 'secondmentType']
